// Generated file : do not modify
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Tranches d'effectifs
export default class TrancheEffectif  {
  // Identifiant unique
  public id: number;
  // Code
  public code: string;
  // Mask paie
  public maskPaie: number;
  // Tranche effectif
  public label: string;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.code = '';
    this.maskPaie = 0;
    this.label = '';
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: TrancheEffectif): TrancheEffectif {
    const newTrancheEffectif: TrancheEffectif = new TrancheEffectif();
    newTrancheEffectif.id = obj.id;
    newTrancheEffectif.code = obj.code;
    newTrancheEffectif.maskPaie = obj.maskPaie;
    newTrancheEffectif.label = obj.label;
    newTrancheEffectif.canUpdate = obj.canUpdate;
    newTrancheEffectif.canDelete = obj.canDelete;
    newTrancheEffectif.display = obj.display;
    newTrancheEffectif.notifDefType = obj.notifDefType;
    return newTrancheEffectif;
  }

  public toJsonTrancheEffectif (): string {
    const json = {
      code: this.code,
      maskPaie: this.maskPaie,
      label: this.label,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromTrancheEffectif (obj: TrancheEffectif): void {
    this.id = obj.id;
    this.code = obj.code;
    this.maskPaie = obj.maskPaie;
    this.label = obj.label;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareTrancheEffectif (value: TrancheEffectif): boolean {
    return (this.toJsonTrancheEffectif() == value.toJsonTrancheEffectif());
  }

  public cloneTrancheEffectif (): TrancheEffectif {
    return TrancheEffectif.fromJson(this);
  }

  public create (): Promise<TrancheEffectif> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/trancheeffectifs/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromTrancheEffectif(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public update (): Promise<TrancheEffectif> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/trancheeffectifs/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromTrancheEffectif(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public delete (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/trancheeffectifs/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/trancheeffectifs/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(trancheEffectifs: TrancheEffectif[]) {
  }
}
